import styled from 'styled-components';
import { flexAlignCenter, flexCenter, rowGap } from '../../styles/utils';

export const ThirdLoginLayout = styled.div`
  margin: 0 auto;
  padding-bottom: var(--padding-lg);

  .divider {
    margin-bottom: 20px !important;
  }
  .ant-divider-inner-text {
    font-size: var(--font-size-lg);
    color: var(--text-color-4);
  }

  .third-login-wrapper {
    ${flexCenter()};
    ${rowGap('32px')};
    .third-logo-parent {
      ${flexAlignCenter()};
      flex-direction: column;
      p {
        padding-top: var(--padding-xxs);
        font-size: var(--font-size-sm);
        color: var(--text-color-4);
      }
    }

    .third-logo {
      width: 40px;
      z-index: 1;
      cursor: pointer;
    }
  }
`;
